import { Component, OnInit, ViewChild, WritableSignal, effect, inject, Injector, ChangeDetectorRef } from "@angular/core"; 
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MessageService, ConfirmationService } from 'primeng/api';

import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Emplacement } from 'src/app/entites/emplacement';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CommandeService } from "src/app/services/commande-service";
import { SignalWithWatcher } from 'src/app/services/base.service';
import { ThemeService } from "src/app/services/theme.service";

@Component({
    templateUrl: './commandes.component.html',
    styleUrls: ['./commandes.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class CommandesComponent extends BaseComponent implements OnInit {

    selectionCommande: Emplacement;
    
    listeEmplacementsActifs: Emplacement[];
    listeEmplacementsFiltres: Emplacement[];
    searchTerm: string = '';

    statsEmplacementsLoading: boolean = false;
    
    viewOptions: any[] = [{ label: 'Tableau', value: 'tableau' },{ label: 'Cartes', value: 'cartes' }];
    value: WritableSignal<string> = this.createLocalStorageSignal('commandes_view', 'cartes');
    
    @ViewChild('dt') table: Table;
    
    injector = inject(Injector);
    private cdr = inject(ChangeDetectorRef);

    private statsSignalWatcher: SignalWithWatcher<Emplacement[]>;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, 
        private breadcrumbService: BreadcrumbService,
        public dialogService: DialogService,
        public routerService: Router,
        private commandeService: CommandeService,
        private messageService: MessageService,
        public themeService: ThemeService
    ) {
        
            super(sdb, profilService, route, routerService, appMain);
            this.breadcrumbService.setItems([
                { label: 'Commandes' }
            ]);

    }

    ngOnInit() {

        this.verifierAccesPage('precommande');

        if (this.profilService.Profil().roles.find(x => x.nom == 'SIHC_Administrateur')) {
            this.listeEmplacementsActifs = this.sdb.Emplacements().filter(x => x.commandeActive);
        } else {
            if (this.profilService.Profil().employe.emplacementIdsCP && this.profilService.Profil().employe.emplacementIdsCP.length > 0) {
                this.listeEmplacementsActifs = this.sdb.Emplacements().filter(x => x.commandeActive && this.profilService.Profil().employe.emplacementIdsCP.includes(x.emplacementId));
            } else if (this.profilService.Profil().taches.find(x => x.code == 'precommande')) {
                this.listeEmplacementsActifs = this.sdb.Emplacements().filter(x => x.commandeActive);
            } else {
                this.listeEmplacementsActifs = [];    
            }
        }

        this.statsEmplacementsLoading = true;
        // Setup effect for real-time updates BEFORE subscribing
        effect(() => {
            if (this.statsSignalWatcher && this.statsSignalWatcher.updates()) { 
                const update = this.statsSignalWatcher.updates(); 
                if (update) {
                    const updatedStats = this.statsSignalWatcher.value();
                    this.listeEmplacementsActifs.forEach(emplacement => {
                        const stats = updatedStats.find(s => s.emplacementId === emplacement.emplacementId);
                        if (stats) {
                            emplacement.nbEnCours = stats.nbEnCours;
                            emplacement.nbEnApprobation = stats.nbEnApprobation;
                            emplacement.nbEnAttente = stats.nbEnAttente;
                            emplacement.nbPret = stats.nbPret;
                            emplacement.nbATraiter = stats.nbATraiter;
                            emplacement.nbCharge = stats.nbCharge;
                            emplacement.nbACommander = stats.nbACommander;
                        }
                    });
                    this.listeEmplacementsFiltres = [...this.listeEmplacementsActifs];
                    this.cdr.detectChanges();
                }
            }
        }, { injector: this.injector });

        this.commandeService.ObtenirStatsEmplacementCommandes().subscribe({
            next: (signalWatcher: SignalWithWatcher<Emplacement[]>) => {
                this.statsSignalWatcher = signalWatcher;
                
                const statsData = signalWatcher.value();
                this.listeEmplacementsActifs.forEach(emplacement => {
                    const stats = statsData.find(s => s.emplacementId === emplacement.emplacementId);
                    if (stats) {
                        emplacement.nbEnCours = stats.nbEnCours;
                        emplacement.nbEnApprobation = stats.nbEnApprobation;
                        emplacement.nbEnAttente = stats.nbEnAttente;
                        emplacement.nbPret = stats.nbPret;
                        emplacement.nbATraiter = stats.nbATraiter;
                        emplacement.nbCharge = stats.nbCharge;
                        emplacement.nbACommander = stats.nbACommander;
                    }
                });
                this.statsEmplacementsLoading = false;
                this.listeEmplacementsFiltres = [...this.listeEmplacementsActifs];
            },
            error: (error) => {
                this.messageService.add({severity:'error', summary:'Erreur', detail:error.error || error, life: 3000});
                this.statsEmplacementsLoading = false;
                this.listeEmplacementsFiltres = [...this.listeEmplacementsActifs];
            }
        });
        
        this.listeEmplacementsFiltres = [...this.listeEmplacementsActifs];
        this.CompleterChargement();
    }

    OuvrirDetailCommande(emplacementId: number) {
        this.routerService.navigateByUrl(`commandes/${emplacementId}`)
    }
    
    toggleView() {
        this.value.set(this.value() === 'tableau' ? 'cartes' : 'tableau');
        
        // Reapply search when switching views
        if (this.searchTerm) {
            const event = { target: { value: this.searchTerm } };
            this.onSearch(event);
        }
    }
    
    onSearch(event: any) {
        const searchValue = event.target.value.toLowerCase();
        this.searchTerm = searchValue;
        
        if (this.value() === 'cartes') {
            // Filter for card view
            this.listeEmplacementsFiltres = this.listeEmplacementsActifs.filter(emplacement => 
                emplacement.nom.toLowerCase().includes(searchValue) || 
                emplacement.code.toLowerCase().includes(searchValue)
            );
        } else {
            // Filter for table view
            if (this.table) {
                this.table.filterGlobal(searchValue, 'contains');
            }
        }
    }
    
    getStatusList() {
        return [
            { key: 'nbEnCours', label: 'En cours', cssClass: 'encours' },
            { key: 'nbEnApprobation', label: 'En approbation', cssClass: 'enapprobation' },
            { key: 'nbEnAttente', label: 'En attente', cssClass: 'enattente' },
            { key: 'nbPret', label: 'Prêt', cssClass: 'prêt' },
            { key: 'nbATraiter', label: 'À traiter', cssClass: 'àtraiter' },
            { key: 'nbCharge', label: 'Chargé', cssClass: 'chargé' },
            { key: 'nbACommander', label: 'À commander', cssClass: 'àfaire' }
        ];
    }
}
